export default __webpack_public_path__ + "images/2cd9953f13bba07dbc9ea70f3b7d3eb3-independence_day.webp";